import { Component, Input } from "@angular/core";

@Component({
    selector: "vsf-filter-skeleton",
    templateUrl: "./filter-skeleton.component.html",
})
export class FilterSkeletonComponent {
    @Input() showSearch = false;
    @Input() showCount = false;
    @Input() itemCount = 4;
}

